import { useSelector } from "react-redux";
import { user_role } from "../consts";

export const useIsPrimaryClientView = () => {
  const { role } = useSelector((st) => st.user);
  const selectedClient = useSelector((st) => st.selected?.primaryClient);

  const isReadOnly =
    selectedClient?._id &&
    (role === user_role.ADMIN || role === user_role.ACCOUNTANT);

  return { isReadOnly, isViewingPrimaryClientPortal: !!selectedClient?._id };
};